import React from 'react';
import PropTypes from 'prop-types';
import { htmlFilter } from '../../utils';
import styles from './feedbackForm.module.scss';

export const Error = ({ isError = false, errors = '' }) => {
    const message = errors
        .split(/<br\/>/g) // the error lines are now separated by br tags
        .filter(item => item.length > 0)
        .map(err => <div key={err}>{htmlFilter(err)}</div>);

    return isError && errors !== '' ? (
        <div className={styles.feedbackError}>{message}</div>
    ) : null;
};

Error.propTypes = {
    isError: PropTypes.bool.isRequired,
    errors: PropTypes.string.isRequired,
};

export const Success = ({ success = false }) => {
    return success ? (
        <div className={styles.feedbackSuccess}>
            <p>
                <strong>Thank you. Your email has been sent.</strong>
            </p>
            <p>
                A player service representative will review your feedback and
                respond as necessary to the email address you provided.
            </p>
        </div>
    ) : null;
};

Success.propTypes = {
    success: PropTypes.bool.isRequired,
};
